import {
  GENERATE_SAAS_TOKEN,
  MFA_CANCEL_ENROLLMENT,
  MFA_COMPLETE_ENROLLMENT,
  MFA_START_ENROLLMENT,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import mfaStartEnrollment from "@shared/services/tour/mockedApis/userProfile/mfaStartEnrollment.ts";
import generateSaasToken from "@shared/services/tour/mockedApis/userProfile/generateSaasToken.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import genericEmptyResponse from "@shared/services/tour/mockedApis/generic/genericEmptyResponse.ts";

export default {
  [MFA_START_ENROLLMENT]: () => mfaStartEnrollment(),
  [MFA_COMPLETE_ENROLLMENT]: () => genericEmptyResponse(),
  [MFA_CANCEL_ENROLLMENT]: () => genericEmptyResponse(),
  [GENERATE_SAAS_TOKEN]: () => generateSaasToken(),
} satisfies TourUrlMapping;
